/** @jsxImportSource @emotion/react */
import React from 'react';
import { fadeDownAnimation } from '../../animations';
import {
  HeaderTitle,
  HeaderQuestion,
} from '../styles/header';

interface QuestionHeaderProps {
  currentQuestionIndex: number;
  totalQuestions: number;
  pendingQuestionsCount: number;
  isLastQuestion?: boolean;
}

export const QuestionHeader: React.FC<QuestionHeaderProps> = ({
  currentQuestionIndex,
  totalQuestions,
  pendingQuestionsCount,
  isLastQuestion = false,
}) => {
  const answeredQuestions = totalQuestions - pendingQuestionsCount;
  const currentQuestionNumber = answeredQuestions + currentQuestionIndex + 1;
  return (
    <div css={fadeDownAnimation(0.4, 0.1)}>
      <HeaderQuestion>
        <HeaderTitle>{isLastQuestion ? 'Next Steps' : `${currentQuestionNumber}/${totalQuestions}`}</HeaderTitle>
      </HeaderQuestion>
    </div>
  );
};
